import { z } from "zod";

export const inviteUserFormConfig = z.object({
    email: z
        .string({ required_error: "validation.required" })
        .email({ message: "validation.email" }),
    role: z.number({ required_error: "validation.required" }).optional(),
});

export type InviteUserFormConfig = z.infer<typeof inviteUserFormConfig>;
